// redux/slices/bookedUsersSlice.js
import { createSlice } from '@reduxjs/toolkit';

const bookedUsersSlice = createSlice({
  name: 'bookedUsers',
  initialState: [],
  reducers: {
    addBookedUser: (state, action) => {
      state.push(action.payload); // payload is the full user object (patient)
    },
  },
});

export const { addBookedUser } = bookedUsersSlice.actions;
export default bookedUsersSlice.reducer;
